module.exports = __webpack_public_path__ + "left-arrow.png?846931b3a29d1c27e1f37532d06208f4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/left-arrow.png
// module id = 970
// module chunks = 2